exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-popover-trigger-icon{cursor:pointer}.share-popover-trigger-text{margin-left:5px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;line-height:14px}", ""]);

// exports
